var map = {
	"./1none.png": "TkbQ",
	"./2none.png": "4T2K",
	"./3none.png": "qlA7",
	"./4none.png": "ba9w",
	"./5none.png": "bm7c",
	"./6none.png": "iRb4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PooD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*none\.png$
// module id = PooD
// module chunks = 0